<h4 class="mb-3">Import details from Teranet search results</h4>
<p>
	Please select the name whose search results you would like to import for
	statements
</p>
<hr class="my-5" />
<div class="grid grid-cols-4 gap-5">
	<div>
		<app-radio-group
			[items]="searchPeople"
			[(ngModel)]="currentItem"
			(ngModelChange)="selectItem($event)"
			orientation="vertical"
		></app-radio-group>
	</div>
	<div class="col-span-3">
		<div *ngIf="!currentNames.data.length">No executions found.</div>
		<div *ngIf="currentNames.data.length">
			<table
				mat-table
				[dataSource]="currentNames"
				[trackBy]="trackByNameId"
				matSort
				class="app-table"
			>
				<ng-container matColumnDef="selected">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>&nbsp;</th>
					<td mat-cell *matCellDef="let element">
						<app-checkbox
							[(ngModel)]="element.selected"
							(ngModelChange)="updatedSelectedWrits()"
							type="clear"
						></app-checkbox>
					</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
					<td mat-cell *matCellDef="let element">{{ element.name }}</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>
				<ng-container matColumnDef="id">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>
						Execution&nbsp;no.
					</th>
					<td mat-cell *matCellDef="let element">{{ element.id }}</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>
				<ng-container matColumnDef="amount">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
					<td mat-cell class="text-right" *matCellDef="let element">
						{{ element.amount | currency }}
					</td>
					<td mat-footer-cell *matFooterCellDef class="text-right">
						<strong>{{ totalAmount | currency }}</strong>
					</td>
				</ng-container>
				<ng-container matColumnDef="plaintiff">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Plaintiff</th>
					<td mat-cell *matCellDef="let element">{{ element.plaintiff }}</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				<tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
			</table>
		</div>
	</div>
</div>
<div *ngIf="totalAmount > 0" class="mt-5">
	<atomic-message-bar *ngIf="totalAmount < 50000" type="success"
		>As the total sum of the executions is less than $50,000, a solicitor
		declaration is not required.</atomic-message-bar
	>
	<atomic-message-bar *ngIf="totalAmount >= 50000" type="info"
		>As the total sum of the executions is $50,000 or more, a solicitor
		declaration will be required.</atomic-message-bar
	>
</div>
<div class="flex justify-between items-center mt-10">
	<app-button btn="tertiary" (click)="cancel()" size="small">Cancel</app-button>
	<app-button
		(click)="import()"
		size="small"
		[loading]="busy"
		[disabled]="busy || !selectedWrits.length"
		>Import statements</app-button
	>
</div>
